export const Login = {
	title: "Logga in",
	description: "Logga in för att låsa upp framtidens hydrauliska plattform.",
	button_text: "Logga in",
	button_text_loading: "Loggar in...",
	error_message: "Inloggningen misslyckades. Försök igen senare.",
	forgot_password_link_text: "Glömt lösenord?",
	microsoft_sso_button_text: "Logga in med Microsoft",
};
